import storage from '~/storage';
import { PrinterSettings, PrinterType } from '~/types/printer';
import { isEnumInclude } from '~/utils/common';

const DEFAULT_SETTINGS: PrinterSettings = {
  type: PrinterType.Bluetooth,
};

const PRINTER_SETTINGS_KEY = 'printer_settings';
let _settings: PrinterSettings = (() => {
  try {
    const value = storage.get(PRINTER_SETTINGS_KEY, null);
    if (!value || !isEnumInclude(PrinterType, value.type)) throw new Error();

    return value;
  } catch (_) {
    return DEFAULT_SETTINGS;
  }
})();

const getSettings = () => _settings;

const saveSettings = (val: PrinterSettings) => {
  _settings = val;
  storage.set(PRINTER_SETTINGS_KEY, val);
};

const printerStore = {
  getSettings,
  saveSettings,
};

export default printerStore;
